import BasePage from "@Scripts/Pages/BasePage";

export default class OrderStatusPage extends BasePage {
    public static async init() {
        await super.init();

        this.setOrderStatus();
    }

    private static setOrderStatus() {
        var items = document.querySelectorAll(".accordion > .item");

        for (const item of items) {
            item.addEventListener("click", x => {
                if (item.getAttribute("data-show") === "show") {
                    items.forEach(x => { x.removeAttribute("data-show") });
                    return;
                }

                items.forEach(x => { x.removeAttribute("data-show") });
                item.setAttribute("data-show", "show");
            });
        }
    }
}